import * as React from "react";
import { Util } from "@grandvisionhq/forms";
import { createFieldIds } from "../../utils/utils/create-field-ids.js";
const getCheckboxKeys = (formState) => {
  return Object.keys(formState).filter((key) => key.startsWith("item-checkbox"));
};
const isAnyCheckboxChecked = (formState) => {
  const checkboxKeys = getCheckboxKeys(formState);
  if (checkboxKeys.length === 1) return true;
  return checkboxKeys.some((key) => formState[key]?.value !== "");
};
const processFormState = (formState) => {
  const checkboxKeys = getCheckboxKeys(formState);
  return checkboxKeys.reduce(
    (acc, key) => {
      const getDefaultFieldState = (fieldKey) => ({
        isTouched: true,
        name: formState[fieldKey]?.name ?? "",
        value: formState[fieldKey]?.value ?? "",
        isValid: !!formState[fieldKey]?.value
      });
      acc[key] = {
        ...getDefaultFieldState(key),
        isValid: isAnyCheckboxChecked(formState) || !!formState[key]?.value
      };
      if (getCheckboxKeys(formState).length === 1 || formState[key]?.value !== "") {
        const [, , index] = key.split("-");
        const fieldIds = createFieldIds(index ?? "");
        acc[fieldIds.reason] = getDefaultFieldState(fieldIds.reason);
        acc[fieldIds.quantity] = {
          ...getDefaultFieldState(fieldIds.quantity),
          isValid: true
        };
      }
      return acc;
    },
    {}
  );
};
const useReturnValidation = () => {
  const isChecked = React.useCallback((formState) => {
    return isAnyCheckboxChecked(formState);
  }, []);
  const validateForm = React.useCallback(
    (formState) => {
      const alteredFormState = processFormState(formState);
      if (!isAnyCheckboxChecked(alteredFormState)) {
        return {
          isValid: false,
          error: "returns.page.selectItems.form.error.noItemSelected"
        };
      }
      if (!Util.getValidityFromState(alteredFormState)) {
        return {
          isValid: false,
          error: "returns.page.selectItems.form.error.reasonRequired"
        };
      }
      return { isValid: true };
    },
    []
  );
  return {
    isAnyCheckboxChecked: isChecked,
    validateForm
  };
};
export {
  useReturnValidation
};
//# sourceMappingURL=use-return-validation.js.map
